import { initSentryRoot } from "@solvari/common-fe/integrations";

// This is in a separate file to take advantage of import side effects running first
initSentryRoot({ project: "morpheus-fe" });
